<template>
<div class="fullWidth fCol jStart aStart gameRow">
  <div class="fullWidth fRow jBetween aStart firstRow" v-if="indx === 0">
    <div class="idx">ردیف</div>
    <div class="gameName growFull">نام گروه</div>
    <div class="groupData fCol jCenter aCenter">تعداد برد و بازی</div>
    <div class="groupData fCol jCenter aCenter">امتیاز</div>
    <div class="groupData fCol jCenter aCenter">تعداد اعضا</div>
    <div class="gameState fCol jCenter aCenter">
      وضعیت گروه
    </div>
    <div class="gameActions fRow jCenter aCenter">
      عملیات
    </div>
  </div>
  <div class="fullWidth fRow jBetween aCenter">
    <div class="idx">{{indx + 1}}</div>
    <div class="gameName growFull">{{data.name}}</div>
    <div class="groupData fCol jCenter aCenter">
      <label class="l">{{data.win}} برد</label>
      <span>از {{data.total}} بازی</span>
    </div>
    <div class="groupData fCol jCenter aCenter">
      <label class="l">{{score(data.score)}} امتیاز</label>
      <span>{{(100 * data.win / data.total).toFixed(1)}}% موفقیت</span>
    </div>
    <div class="groupData fCol jCenter aCenter">
      <label class="l">{{data.users}} عضو</label>
      <div class="b fRow jCenter aCenter mini">
        <i class="material-icons-round">groups</i>
        <label>مشاهده‌ی اعضا</label>
      </div>
    </div>
    <div class="gameState fCol jCenter aCenter">
      <switch-button
        @click.native="switchStatus"
        activeLabel="فعال"
        deactiveLabel="غیرفعال"
        :val="gameStatus"/>
    </div>
    <div class="gameActions fRow jCenter aCenter">
      <i class="material-icons-round gameAction d transition-fast" @click="deleteItem">delete</i>
    </div>
    <div class="deleteModal fRow jCenter aCenter wrap" v-if="deleteModal">
      <h3 class="">آیا از حذف {{data.name}} مطمئنید؟</h3>
      <div class="b fRow jStart aCenter delete" @click="alert('delete')">
        <i class="material-icons-round">delete</i>
        <label>حذف آیتم</label>
      </div>
      <div class="b fRow jStart aCenter" @click="deleteModal = false">
        <label>بازگشت</label>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import SwitchButton from '@/components/SwitchButton.vue';
import '@/assets/new.scss';
import '@/assets/gameRowStyle.scss';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'indx'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      gameStatus: false,
      deleteModal: false,
    };
  },
  components: {
    SwitchButton,
  },
  methods: {
    getGrades(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Grades`;
      if (f !== -1) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Grades?field=${f}`;
      } else {
        return;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          this.grades.push({
            id: '',
            title: 'حذف فیلتر',
          });
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
          // console.warn(this.grades);
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    switchStatus() {
      this.gameStatus = !this.gameStatus;
      // request here
    },
    deleteItem() {
      this.deleteModal = true;
    },
    score(x) {
      let a = `${x}`;
      if (x > 999) {
        a = `${(x / 1000).toFixed(2)}K`;
      }
      return a;
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.gameStatus = this.data.status;
  },
};
</script>

<style lang="scss" scoped>
</style>
